import { render, staticRenderFns } from "./ChangeSummaryDataTable.vue?vue&type=template&id=cb7f0464&scoped=true&"
import script from "./ChangeSummaryDataTable.vue?vue&type=script&lang=js&"
export * from "./ChangeSummaryDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSummaryDataTable.vue?vue&type=style&index=0&id=cb7f0464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7f0464",
  null
  
)

export default component.exports